import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import { PageHeader, Popconfirm, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import AgregarRegistroPatronal from "./AgregarRegistroPatronal/AgregarRegistroPatronal";
import EditarRegistroPatronal from "./EditarRegistroPatronal/EditarRegistroPatronal";

moment.locale("es");

class RegistrosPatronales extends Component {
  tableRef = null;
  state = {
    todosRegistrosPatronales: [],
    loading: false,
    valor: 1,
    modalAgregarRegistroPatronal: false,
    modalEditarRegistroPatronal: false,
    modalEditarRegistroPatronalId: null,
  };

  consultarRegistrosPatronales(params) {
    this.setState({ loading: true });
    axios
      .post(
        "registrosPatronales/selectTodasRegistrosPatronales",
        { empresaId: this.props.empresaId, ...params },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          this.setState({ todosRegistrosPatronales: [] });
        } else {
          this.setState({
            todosRegistrosPatronales: res.data.data,
            totalRecords: res.data.totalRecords || 0,
          });
        }
      });
  }

  deshabilitarRegistroPatronal(value) {
    axios
      .post(
        "registrosPatronales/deshabilitarRegistroPatronal",
        { registroPatronalId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) message.success("Registro patronal deshabilitado");
        else message.error("Sucedió un error y no se pudo deshabilitar");
        if (this.tableRef) this.tableRef.updateExternalFilters({ valor: this.state.valor });
      });
  }

  habilitarRegistroPatronal(value) {
    axios
      .post(
        "registrosPatronales/habilitarRegistroPatronal",
        { registroPatronalId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) message.success("Registro patronal habilitado");
        else message.error("Sucedió un error y no se pudo habilitar");
        if (this.tableRef) this.tableRef.updateExternalFilters({ valor: this.state.valor });
      });
  }

  agregarRegistroPatronal() { this.setState({ modalAgregarRegistroPatronal: true }); }
  cerrarAgregarRegistroPatronal() {
    this.setState({ modalAgregarRegistroPatronal: false });
    this.tableRef.updateExternalFilters({ valor: this.state.valor });
  }

  editarRegistroPatronal(id) { this.setState({ modalEditarRegistroPatronal: true, modalEditarRegistroPatronalId: id }); }
  cerrarEditarRegistroPatronal() {
    this.setState({ modalEditarRegistroPatronal: false });
    this.tableRef.updateExternalFilters({ valor: this.state.valor });
  }

  render() {
    const columns = [
      {
        title: "Número",
        dataIndex: "numero",
        key: "numero",
        buscar: "serieNumero",
        render: (value, record) => `${record.serie} - ${record.numero}`,
        width: "6%",
      },
      {
        title: "Registro Patronal IMSS",
        dataIndex: "registroPatronalIMSS",
        key: "registroPatronalIMSS",
        buscar: "registroPatronalIMSS",
        width: "16%",
      },
      {
        title: "Entidad Federativa",
        dataIndex: "entidadFederativa",
        key: "entidadFederativa",
        width: "14%",
        render: (value) => value || "—",
      },
      {
        title: "Clase Riesgo",
        dataIndex: "claseRiesgo",
        key: "claseRiesgo",
        width: "12%",
        render: (value) => value || "—",
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        width: "8%",
        render: (value) => {
          if (value === 1) return <Tag color="green">Activo</Tag>;
          if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
          return "—";
        },
      },
      {
        title: "Acción",
        key: "accion",
        width: "10%",
        render: (_, record) => {
          const buttons = [];

          buttons.push(
            <Tooltip key={`editar-${record._id}`} title="Editar Registro Patronal" placement="top"
              overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
              <ButtonItem type="default" size="small" cyan icon={<EditOutlined />}
                onClick={() => this.editarRegistroPatronal(record._id)} />
            </Tooltip>
          );

          if (record.estado === 1) {
            buttons.push(
              <Popconfirm key={`deshabilitar-${record._id}`}
                title="¿Seguro que quieres deshabilitar este registro patronal?"
                onConfirm={() => this.deshabilitarRegistroPatronal(record._id)}
                okText="Sí" cancelText="No">
                <Tooltip title="Deshabilitar" placement="top"
                  overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
                  <ButtonItem type="default" size="small" lima icon={<CheckCircleOutlined />} />
                </Tooltip>
              </Popconfirm>
            );
          } else {
            buttons.push(
              <Popconfirm key={`habilitar-${record._id}`}
                title="¿Seguro que quieres habilitar este registro patronal?"
                onConfirm={() => this.habilitarRegistroPatronal(record._id)}
                okText="Sí" cancelText="No">
                <Tooltip title="Habilitar" placement="top"
                  overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
                  <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} />
                </Tooltip>
              </Popconfirm>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="Registros Patronales"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={
            <>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[{ label: "Vigente", value: 1 }, { label: "Deshabilitado", value: 2 }, { label: "Todos", value: 3 }]}
                  onChange={(value) => {
                    if (this.tableRef) this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              )}
              <ButtonItem type="primary" key="agregarRegistroPatronal"
                onClick={this.agregarRegistroPatronal.bind(this)}>
                Agregar Registro Patronal
              </ButtonItem>
            </>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          onFetchData={this.consultarRegistrosPatronales.bind(this)}
          anadirValorFiltro={this.state.valor}
          size="small"
          onlyMineFilter
          dataSource={this.state.todosRegistrosPatronales}
          columns={columns}
          scroll={{ x: "max-content" }}
          filterStorageKey={"registrosPatronales" + this.props.empresaId}
          onRow={(record) => ({
            onDoubleClick: () => this.editarRegistroPatronal(record._id),
          })}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={1}
        />
        <AgregarRegistroPatronal
          visible={this.state.modalAgregarRegistroPatronal}
          cerrarAgregarRegistroPatronal={this.cerrarAgregarRegistroPatronal.bind(this)}
        />
        <EditarRegistroPatronal
          visible={this.state.modalEditarRegistroPatronal}
          registroPatronalId={this.state.modalEditarRegistroPatronalId}
          cerrarEditarRegistroPatronal={this.cerrarEditarRegistroPatronal.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(RegistrosPatronales);